// Идентификаторы интеграций
export const EMAIL_HANDLER = 'email-handler';
export const ENVELOPE = 'envelope';
export const WHATSAPP = 'whatsapp';
export const INSTAGRAM = 'instagram';
export const VK = 'vk';
export const TELEGRAM = 'telegram'; // telegram - bot
export const ATC_BEELINE = 'atc-beeline';
export const ATC_MANGO = 'atc-mango';
export const YOO_KASSA = 'yookassa';
export const TELEGRAM_PERSONAL = 'telegram-personal';
export const MAX_MESSENGER = 'max';
export const LOYALTY_PROGRAM_SENDOUTS = 'loyalty-program-sendouts';
export const NEW_LEAD_INTEGRATION = 'new-lead';
export const SMS_SERVICE = 'sms-service';
// Системная интеграция «Техническая поддержка» (US 11021). Существует только в
// организации Бизнес Решение, создаётся на бэке; фронт её показывает, но
// запрещает удаление и правку всего, кроме воронок продаж.
export const TECH_SUPPORT = 'tech-support';

// Названия интеграций
export const EMAIL_LABEL = 'Email';
export const WHATSAPP_LABEL = 'WhatsApp';
export const INSTAGRAM_LABEL = 'Instagram';
export const VK_LABEL = 'ВКонтакте';
export const TELEGRAM_LABEL = 'Telegram Bot';
export const ATC_BEELINE_LABEL = 'Beeline';
export const ATC_MANGO_LABEL = 'Mango telecom';
export const TELEGRAM_PERSONAL_LABEL = 'Telegram (личный)';
export const MAX_MESSENGER_LABEL = 'MAX';
export const LOYALTY_PROGRAM_SENDOUTS_LABEL = 'Рекомендуй';
export const NEW_LEAD_INTEGRATION_LABEL = 'Новый лид';
export const SMS_SERVICE_LABEL = 'SMS-сервис';
export const TECH_SUPPORT_LABEL = 'Техническая поддержка';

// Справочник идентификаторов и названий
export const INTEGRATIONS_DICTIONARY = [
  {
    id: EMAIL_HANDLER,
    name: EMAIL_LABEL,
  },
  {
    id: WHATSAPP,
    name: WHATSAPP_LABEL,
  },
  {
    id: INSTAGRAM,
    name: INSTAGRAM_LABEL,
  },
  {
    id: VK,
    name: VK_LABEL,
  },
  {
    id: TELEGRAM,
    name: TELEGRAM_LABEL,
  },
  {
    id: ATC_BEELINE,
    name: ATC_BEELINE_LABEL,
  },
  {
    id: TELEGRAM_PERSONAL,
    name: TELEGRAM_PERSONAL_LABEL,
  },
  {
    id: MAX_MESSENGER,
    name: MAX_MESSENGER_LABEL,
  },
  {
    id: LOYALTY_PROGRAM_SENDOUTS,
    name: LOYALTY_PROGRAM_SENDOUTS_LABEL,
  },
  {
    id: SMS_SERVICE,
    name: SMS_SERVICE_LABEL,
  },
  {
    id: TECH_SUPPORT,
    name: TECH_SUPPORT_LABEL,
  },
];
